export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7267.540a2e55.jpg";